import React, { useState } from 'react'
import {
  Button,
  Text,
  Box,
  Divider,
  Link,
  PinInput,
  PinInputField,
  HStack,
  useDisclosure
} from '@chakra-ui/react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { ActionModal, AuthLayout, BaseHeading } from '../../components'
import { ROUTES } from '../../contants'
import useResetStore from '../../state/Reset.store'
import { screens } from './types'

const VerifyOTP = () => {
  const [Error, setError] = useState(false)
  const [otp, setOTP] = useState('')
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [loading, verifyOTP, errorMessage, setScreen, email, sendOTP] = useResetStore((state) => [
    state.loading,
    state.verifyOTP,
    state.errorMessage,
    state.setScreen,
    state.email,
    state.sendOTP
  ])

  const submit = async () => {
    if (otp.length < 6) {
      setError(true)
      return
    }
    try {
      await verifyOTP(otp)
      setScreen(screens.RESET_PIN)
    } catch (error) {
      onOpen()
    }
  }
  return (
    <AuthLayout>
      <Box>
        <BaseHeading title="PIN Reset" />
        <Text fontSize="1.2rem" mb="3.2rem">
          If you recognize this activity, kindly enter the OTP sent to your phone or email.
        </Text>

        <HStack>
          <PinInput
            errorBorderColor="red.400"
            isInvalid={Error}
            onChange={(e) => setOTP(e)}
            size="lg"
            otp
            placeholder="">
            {Array(6)
              .fill('')
              .map(() => (
                <PinInputField color="black" />
              ))}
          </PinInput>
        </HStack>

        <Button isLoading={loading} onClick={submit} my="2.4rem" isFullWidth variant="blue">
          Verify
        </Button>
        <Text fontWeight="500" mb="8.7rem" textAlign="center">
          Didn’t get the code?{' '}
          <Text
            as="button"
            disabled={loading}
            _disabled={{ cursor: 'not-allowed', opacity: 0.7 }}
            onClick={() => sendOTP(email)}
            fontWeight="500"
            color="brand.blue">
            Resend OTP
          </Text>
        </Text>
        <Divider mb="2rem" />
        <Text textAlign="center">
          Get Started{' '}
          <Link
            fontWeight="500"
            color="brand.blue"
            as={RouterLink}
            to={ROUTES.insurance}
            _hover={{ border: 'none', outline: 'none' }}
            _active={{ border: 'none', outline: 'none' }}
            _focus={{ border: 'none', outline: 'none' }}>
            Buy Insurance
          </Link>
        </Text>
      </Box>

      <ActionModal
        action="Try Again"
        error
        message={errorMessage || 'An Error Occured'}
        isOpen={isOpen}
        onClose={onClose}
      />
    </AuthLayout>
  )
}

export { VerifyOTP }
